<template>
  <nav class="navbar sticky-top navbar-expand-lg bg-body-tertiary">
    <div class="container">
      <div id="logo">
        <a :href="logourl"><img src="../assets/images/Axes.png" alt="" /></a>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        class="collapse navbar-collapse flex-grow-0"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a
              v-if="homepage"
              class="nav-link"
              href="https://axes.com.pl"
              target="_blank"
              >Strona Axes</a
            >
            <a v-if="homeview" class="nav-link" href="#"
              >Informacje o abonamencie</a
            >
            <a v-if="regloginpass" class="nav-link" href="/rental"
              >Strona główna</a
            >
          </li>
          <li class="nav-item">
            <a v-if="homepage" class="nav-link" href="/" target="_blank"
              >Strona CDIF/3</a
            >
            <a v-if="homeview" class="nav-link" href="#userData">Moje dane</a>
            <a
              v-if="regloginpass"
              class="nav-link"
              href="https://axes.com.pl"
              target="_blank"
              >Strona Axes</a
            >
          </li>
          <li class="nav-item">
            <a
              v-if="homepage"
              class="nav-link"
              href="/rental/regulations"
              target="_blank"
              >Regulamin usługi</a
            >
            <a v-if="homeview" class="nav-link" href="#payment"
              >Historia płatności</a
            >
            <a v-if="regloginpass" class="nav-link" href="/" target="_blank"
              >Strona CDIF/3</a
            >
          </li>
          <li class="nav-item">
            <a
              v-if="homepage"
              class="nav-link"
              href="https://www.youtube.com/@axessystem6087"
              target="_blank"
              >YouTube</a
            >
            <a v-if="homeview" class="nav-link" href="#contact">Kontakt</a>
            <a
              v-if="regloginpass"
              class="nav-link"
              href="/rental/regulations"
              target="_blank"
              >Regulamin usługi</a
            >
          </li>
          <li class="nav-item">
            <a v-if="homepage" class="nav-link" href="#contact">Kontakt</a>
            <a v-if="homeview"
               class="nav-link"
               href="/rental/regulations"
               target="_blank"
              >Regulamin usługi</a
            >
            <a
              v-if="regloginpass"
              class="nav-link"
              href="https://www.youtube.com/@axessystem6087"
              target="_blank"
              >YouTube</a
            >
          </li>
          <li v-if="homeview || homeviewsubpage" class="nav-item">
            <a class="nav-link" style="cursor: pointer" @click="onLogoutClick"
              >Wyloguj</a
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { makeRequest } from "@/utils/helpers";
import { RequestResult } from "@/utils/requestResult";

export default {
  name: "Navbar",

  props: {
    homepage: Boolean,
    homeview: Boolean,
    homeviewsubpage: Boolean,
    regloginpass: Boolean,
    logourl: String,
  },

  methods: {
    async onLogoutClick() {
      let data = {
        action: this.request.Logout,
      };

      let logoutRequestResponse = await makeRequest(data);

      switch (logoutRequestResponse.data.error) {
        case RequestResult.OK: {
          this.$router.push(this.routePath.Login);
          break;
        }
        case RequestResult.GeneralError: {
          // nie udało się wylogować
          // co tu zrobić?
          console.log("nie udało się wylogować");
          break;
        }
        case RequestResult.InvalidCookie:
        case RequestResult.CookieExpired: {
          console.log("invalid cookie or cookie expired");
          this.$router.push(this.routePath.Login);
          break;
        }
      }
    },
  },
};
</script>

<style scoped></style>
